import { Button } from "primereact/button";
import { classNames } from "primereact/utils";

import { useFilterPanelContext } from "../filter-panel.context";
import styles from "../filter-panel.module.scss";
import { FILTERS_LABEL } from "../messages";
import type { FilterPanelHeaderProps } from "../types-filter-panel";

export function FilterPanelHeader({ children, className, ...rest }: FilterPanelHeaderProps) {
  const panel = useFilterPanelContext();

  return (
    <header className={classNames(styles.header, panel.classNames.header, className)} {...rest}>
      <h2 className={styles.title}>
        {FILTERS_LABEL}
        {panel.showCount ? (
          <span className={styles.count} data-testid={panel.partTestId("count")}>
            {panel.activeCount}
          </span>
        ) : null}
      </h2>
      <div className={styles.headerActions}>
        {children}
        {panel.collapsible ? (
          <Button
            type="button"
            icon={panel.collapseIcon}
            text
            rounded
            severity="secondary"
            aria-label={panel.collapseLabel}
            aria-expanded={!panel.collapsed}
            onClick={panel.toggleCollapsed}
            data-testid={panel.partTestId("collapse")}
          />
        ) : null}
      </div>
    </header>
  );
}
FilterPanelHeader.displayName = "FilterPanel.Header";
